<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
  <div class="flex-header">
    <student-header [showYearSelector]="true" [pageTitle]="'Health'"></student-header>
  </div>
  <tabs [hidden]="tabNames.length == 0" [tabNames]="tabNames" [setIndex]="setIndex"
    (selectionsChangeIndex)="selectionChange($event)"></tabs>
  <div class="flex-content" style="height: 100%;">
    <div #tabContent style="height: 100%;" *ngIf="tabNames && tabNames.length > 0">
      <div #divHealthCondition *ngIf="selectedTabName == 'Health Conditions'">
        <app-health-condition [selectedStudent]="selectedStudent"></app-health-condition>
      </div>
      <div #divImmunizations *ngIf="selectedTabName == 'Immunizations'">
        <app-immunizations [selectedStudent]="selectedStudent"></app-immunizations>
      </div>
      <div #divMedications *ngIf="selectedTabName == 'Medications'">
        <app-medications [selectedStudent]="selectedStudent"></app-medications>
      </div>
      <div #divHealthVisitLog *ngIf="selectedTabName == 'Health Visit Log'">
        <app-health-visit-log [selectedStudent]="selectedStudent" [studentEnrollment]="studentEnrollment">
        </app-health-visit-log>
      </div>
      <div #divDoctors *ngIf="selectedTabName == 'Practitioners'">
        <app-doctors [selectedStudent]="selectedStudent"></app-doctors>
      </div>
      <div #divPregnancy *ngIf="selectedTabName == 'Pregnancy'">
        <app-pregnancy [selectedStudent]="selectedStudent"></app-pregnancy>
      </div>
      <div #divRestrictions *ngIf="selectedTabName == 'Restrictions'">
        <app-restrictions [selectedStudent]="selectedStudent"></app-restrictions>
      </div>
      <div #divInsurance *ngIf="selectedTabName == 'Insurance'">
        <app-insurance [selectedStudent]="selectedStudent"></app-insurance>
      </div>
      <div #divScreening *ngIf="selectedTabName == 'Screenings'">
        <app-screening [selectedStudent]="selectedStudent"></app-screening>
      </div>
      <div #divHearing *ngIf="selectedTabName == 'Hearing'">
        <app-hearing [selectedStudent]="selectedStudent"></app-hearing>
      </div>
      <div #divVision *ngIf="selectedTabName == 'Vision'">
        <app-vision [selectedStudent]="selectedStudent"></app-vision>
      </div>
      <div #divDental *ngIf="selectedTabName == 'Dental'">
        <app-dental [selectedStudent]="selectedStudent"></app-dental>
      </div>
      <div #divSpinal *ngIf="selectedTabName == 'Spinal'">
        <app-spinal [selectedStudent]="selectedStudent"></app-spinal>
      </div>
      <div #divPhysicalExam *ngIf="selectedTabName == 'Physical Exam'">
        <app-physical-exam [selectedStudent]="selectedStudent"></app-physical-exam>
      </div>
    </div>
    <div style="text-align:center;" *ngIf="tabNames.length == 0" translate>No health information has been enabled by the
      administration.</div>
  </div>
</tyl-kendo-pdf-export>
<div class="flex-footer">

  <!-- Left -->
  <div class="flex-footer-left">
    <tyl-button #btnExpandAll image="Expand All.png" label="Expand All" (clickEvent)="expandAll(true)"
      *ngIf="selectedTabName == 'Medications' "></tyl-button>
    <tyl-button #btnCollapseAll image="Collapse All.png" label="Collapse All" (clickEvent)="expandAll(false)"
      *ngIf="selectedTabName == 'Medications'"></tyl-button>
    <!-- <tyl-button #btnCodeLegend image="Code Legend.png" label="Legend" (clickEvent)="codeLegendClick()" *ngIf="selectedTabName == 'Screenings'"></tyl-button> -->
  </div>

  <!-- Middle -->
  <div class="flex-footer-middle" style="align-items: center">
    <filter-notification [filtered]="isCurrentTabFiltered()" (clearFilter)="clearCurrentTabFilters()">
    </filter-notification>
  </div>

  <!-- Right -->
  <div class="flex-footer-right"></div>
</div>